import {z} from '@hono/zod-openapi';

export const hondaMonthlyReportResponseSchema = z
  .object({
    fileId: z.string().openapi({example: 'a1b2c3d4-...'}),
    downloadUrl: z.string().openapi({example: 'https://storage.example.com/...'}),
    expiresAt: z.string().openapi({example: '2026-09-08T12:55:35Z'}),
    filename: z.string().openapi({example: '067_202512_monthly-report.xml'}),
  })
  .openapi('HondaMonthlyReportResponse');

export type HondaMonthlyReportResponse = z.infer<typeof hondaMonthlyReportResponseSchema>;
